import { render, staticRenderFns } from "./traningAssess.vue?vue&type=template&id=33e074de"
import script from "./traningAssess.vue?vue&type=script&lang=js"
export * from "./traningAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e074de')) {
      api.createRecord('33e074de', component.options)
    } else {
      api.reload('33e074de', component.options)
    }
    module.hot.accept("./traningAssess.vue?vue&type=template&id=33e074de", function () {
      api.rerender('33e074de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/traningAssess.vue"
export default component.exports